
import {CANDIDATE_JOB_PLANNED_REQUEST, CANDIDATE_JOB_PLANNED_SUCCESS,CANDIDATE_JOB_PLANNED_FAIL} from "../constants/AuthConstant"

const axios = require("axios");
export const CandidateInterviewPlanned = (id,pageNumber) => {
    return function (dispatch) {
      dispatch({
        type: CANDIDATE_JOB_PLANNED_REQUEST,
        payload: true,
      });
      let OPTION = {
        url: `${process.env.REACT_APP_API_PATH}/ebench/interview/get_interview_scheduled_by_candidateId?candidateId=${id}&pageNumber=${pageNumber}&pageSize=10&flag=true`,
        method: "GET",
        headers: {
          "content-type": "application/json",
        },
      };
      axios(OPTION)
        .then((res) => {
          dispatch(loadAllDetailsPre(res.data));
        })
        .catch((error) => {
          dispatch({
            type: CANDIDATE_JOB_PLANNED_FAIL,
            payload: false,
            error: error,
            msg: "Failed to load the information",
          });
        });
    };
  };

  export const loadAllDetailsPre = (data) => {
    return {
      type: CANDIDATE_JOB_PLANNED_SUCCESS,
      result: data,
      payload: false,
      msg: "SUCCESS",
    };
  };